import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';

import CommonTheme from '../../Theme.js';
import {CopyRight, AppVersion} from '../atoms/CopyRight.js';
import {useFunctionQuery} from '../atoms/withMediaQuery.js';

const useStyles = makeStyles((theme) => ({
  footer: {
    background: 'rgb(114, 160, 209)',
    position: 'fixed',
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '75px',
    overflow: 'hidden',
    padding: '10px 0px 10px 0px',
    zIndex: theme.zIndex.drawer + 1,

    [theme.breakpoints.up(
        CommonTheme.breakpoints.values.lg + CommonTheme.menu.width)]: {
      maxWidth: 'calc(' + CommonTheme.breakpoints.values.lg + 'px + ' + CommonTheme.menu.width + 'px)',
      width: '100%',
    },
    [theme.breakpoints.down('md')]: {
      // スマホ解像度の場合はスクロールバー表示
      overflowY: 'scroll',
    },
    [theme.breakpoints.up('sm')]: {
      // スマホ解像度を超える場合スクロールバー非表示
      // IE, 旧Edge 対応
      '-ms-overflow-style': 'none', /* IE, Edge 対応 */

      // 新Edge, Chrome, Safari 対応
      '&::-webkit-scrollbar': {
        display: 'none',
      },

      // Firefox対応
      'scrollbarWidth': 'none',
    },
  },
}));

export default function Footer({children, isCopyRight=true, isVersion=true}) {
  const classes = useStyles();
  const isMobile = useFunctionQuery();

  return (
    <div className="bf-form-root">
      <footer className={classes.footer}>
        {children}
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction="row"
          sx={{padding: '5px'}}
        >
          <Grid key="footer1" item xs={12} sm={2}>
          </Grid>
          <Grid key="footer2" item xs={12} sm={8}>
            {isCopyRight && <CopyRight/>}
          </Grid>
          {!isMobile && <Grid key="footer3" item xs={12} sm={2}>
            {isVersion && <AppVersion/>}
          </Grid>}
        </Grid>
      </footer>
    </div>
  );
};

Footer.propTypes = {
  children: PropTypes.object,
  isCopyRight: PropTypes.bool,
  isVersion: PropTypes.bool,
};
